// extracted by mini-css-extract-plugin
export default {"headerTab":"header_headerTab__at4E+","tab":"header_tab__YUs4C","tabItem":"header_tabItem__wI-d1","right":"header_right__4+IO9"};